import React, { useEffect, useRef } from 'react';

import useDatasetExport, {
  UseDatasetExportParams,
} from '../hooks/useDatasetExport';

export interface DatasetExportControllerProps extends UseDatasetExportParams {
  pendingAction: 'csv' | 'excel' | null;
  onActionHandled: () => void;
}

const DatasetExportController = ({
  pendingAction,
  onActionHandled,
  ...exportParams
}: DatasetExportControllerProps): React.JSX.Element => {
  const { exportCSV, exportExcel, excelExportDialog } =
    useDatasetExport(exportParams);

  const exportCSVRef = useRef(exportCSV);
  exportCSVRef.current = exportCSV;
  const exportExcelRef = useRef(exportExcel);
  exportExcelRef.current = exportExcel;
  const onActionHandledRef = useRef(onActionHandled);
  onActionHandledRef.current = onActionHandled;

  useEffect(() => {
    if (!pendingAction) return;
    if (pendingAction === 'csv') {
      exportCSVRef.current();
    } else {
      exportExcelRef.current();
    }
    onActionHandledRef.current();
  }, [pendingAction]);

  return <>{excelExportDialog}</>;
};

export default DatasetExportController;
